module.exports = __webpack_public_path__ + "static/mandalabackground-07bedc1b350d69a5619c687b14dc9a84.png";